import { observer } from 'mobx-react-lite'
import { useOutletContext } from 'react-router'
import { BundleManagerPageContainer } from '@/features/admin/bundle/BundleManager/BundleManagerPage/BundleManagerPageContainer'
import { type AdminViewModel } from '@/features/admin/AdminViewModel'

export default observer(function AdminBundleManagerContainer() {
  const vm = useOutletContext<AdminViewModel>()
  return <BundleManagerPageContainer vm={vm.bundleManagerVm} />
})
